import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ISuperTableReconcileItem } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { cloneDeep } from 'lodash-es';
import { MappingItemsSelectionNode } from '../../../../interfaces/mapping-items-selection-node.interface';
import { SuperTableMapper } from '../../../../mappers/super-table.mapper';

@UntilDestroy()
@Component({
    selector: 'super-table-reconcile',
    templateUrl: 'reconcile.component.html',
    styleUrls: ['reconcile.component.scss'],
})
export class SuperTableReconcileComponent implements OnChanges {
    @Input() set mappingItemsSelectionTree(value: MappingItemsSelectionNode | undefined) {
        this.modifiedMappingItemsSelectionTree = cloneDeep<MappingItemsSelectionNode>(value);
    }

    @Input() existingReconcileSelectionItems: ISuperTableReconcileItem[] | undefined | null;
    @Input() language: string | undefined;
    @Output() selectedItem: EventEmitter<MappingItemsSelectionNode[] | null> = new EventEmitter<
        MappingItemsSelectionNode[] | null
    >();

    existingReconcileSelectionItemNodes: MappingItemsSelectionNode[] | null | undefined = [];
    modifiedMappingItemsSelectionTree: MappingItemsSelectionNode | null | undefined;

    constructor(private readonly superTableMapper: SuperTableMapper) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (
            (changes['existingReconcileSelectionItems']?.currentValue != null &&
                this.mappingItemsSelectionTree != null) ||
            (changes['mappingItemsSelectionTree']?.currentValue != null && this.existingReconcileSelectionItems != null)
        ) {
            for (const existingReconcileSelectionItem of this.existingReconcileSelectionItems) {
                const existingReconcileSelectionItemNode = cloneDeep<MappingItemsSelectionNode | null>(
                    this.superTableMapper.findMatchingNodeForReconcileItem(
                        existingReconcileSelectionItem,
                        this.modifiedMappingItemsSelectionTree,
                    ),
                );

                if (existingReconcileSelectionItemNode != null) {
                    this.existingReconcileSelectionItemNodes.push(existingReconcileSelectionItemNode);
                } else {
                    throw new Error('found no match for existingReconcileSelectionItemNode');
                }
            }

            this.modifiedMappingItemsSelectionTree = cloneDeep<MappingItemsSelectionNode>(
                this.superTableMapper.SelectMatchingNodes(
                    this.existingReconcileSelectionItemNodes,
                    this.modifiedMappingItemsSelectionTree,
                ),
            );

            this.selectedItem.emit(this.existingReconcileSelectionItemNodes);
        }
    }

    onSelectedItemChange(selectedItem: MappingItemsSelectionNode[] | null): void {
        this.selectedItem.emit(selectedItem);
    }
}
